import { PresetSchema } from "@redotech/redo-model/outbound-labels/presets";
import { z } from "zod";

export const getPresets = {
  input: z.object({}),
  output: z.object({ presets: z.array(PresetSchema) }),
};
